import React, { useState } from "react";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";

const QuantityIndecator = (props) => {
  return (
    <>
      <div
        className="row align-items-center fw-600"
        style={{ padding: "12px 0px" }}
      >
        <div
          className="col-auto d-flex align-items-center"
          style={{ padding: "6px" }}
        >
          <Tag
            value="G"
            className={`px-3 py-2 fw-bold fs-6 ${
              props?.activeTag === "G"
                ? "btn-primary text-white"
                : "btn-light text-dark"
            }`}
            style={{
              borderRadius: "10px",
              border: "none",
              height: "25px",
              width: "40px",
              backgroundColor: props?.activeTag === "G" ? "#002D42" : "#E0E0E0",
              cursor: "pointer",
            }}
            onClick={() => props?.handleTagClick("G")}
          />
        </div>
        <div
          className="col-auto d-flex align-items-center"
          style={{ padding: "0px" }}
        >
          <Tag
            value="Oz"
            className={`px-3 py-2 fw-bold fs-6 ${
              props?.activeTag === "OZ"
                ? "btn-primary text-white"
                : "btn-light text-dark"
            }`}
            style={{
              borderRadius: "10px",
              border: "none",
              height: "25px",
              width: "40px",
              backgroundColor:
                props?.activeTag === "OZ" ? "#002D42" : "#E0E0E0",
              cursor: "pointer",
            }}
            onClick={() => props?.handleTagClick("OZ")}
          />
        </div>
      </div>
      <Divider type="solid" />
    </>
  );
};

export default QuantityIndecator;
